export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      // Currently unsupported for 9141C
      //   {
      //     formCommonName: "CW-1 PREVAILING WAGE",
      //     formGovName: "FORM ETA-9141C",
      //     sections: ["SECTION C"],
      //   },
      // Currently unsupported for 9142C
      //   {
      //     formCommonName: "CW-1 LABOR CERTIFICATION",
      //     formGovName: "FORM ETA-9142C",
      //     sections: ["SECTION B"],
      //   },
      {
        formCommonName: "H-2A AGRICULTURAL CLEARANCE ORDER",
        formGovName: "FORM ETA-790",
        sections: ["SECTION II"],
      },
      {
        formCommonName: "H-2A TEMPORARY LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142A",
        sections: ["SECTION B"],
      },
      {
        formCommonName: "H-2B | H-1B | PERM PREVAILING WAGE",
        formGovName: "FORM ETA-9141",
        sections: ["SECTION C"],
      },
      {
        formCommonName: "PERM PERMANENT EMPLOYMENT CERTIFICATION",
        formGovName: "FORM ETA-9089",
        sections: ["SECTION A"],
      },
      // Currently unsupported for 9142B
      //   {
      //     formCommonName: "H-2B LABOR CERTIFICATION",
      //     formGovName: "FORM ETA-9142B",
      //     sections: ["SECTION C"],
      //   },
    ],
  },
};
